export default function auth ({ next, store, nextMiddleware }) {
  if (!store.getters.logged) {
    return next({ name: 'login' });
  }
  return nextMiddleware();
}
